<template>
  <section>
    <div class="container clearfix py-5">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10 col-12">
          <h1>Vizyonumuz</h1>
          <p class="text-justify lead mb-2">
            Değişirken/iyileşirken, ekosistemini de etkile/değiştir
          </p>
          <ul class="pl-4 mb-2">
            <li class="lead">
              Ekosistemine değişim için destek ol, onların da kendi
              ekosistemlerini etkilemesini kolaylaştır
            </li>
            <li class="lead">Değişimi raporla, paylaş, ilham ver</li>
          </ul>
          <p class="text-justify lead mb-2">
            BG Platformu üyesi bir şirket ne yapar?
          </p>
          <ol class="pl-3 mb-2">
            <li class="lead">
              <b>
                WEPs ilkelerini rehber alır ve kadının güçlenmesi için şirket
                içinde bir değişim hikayesi başlatır, uygular, raporlar ve
                iletişimini yapar:
              </b>
              <ul class="pl-4 mb-2">
                <li class="lead">Mevcut durumuna bakar</li>
                <li class="lead">
                  Mevcut durumuna göre kısa ve uzun vade hedeflerini belirler
                </li>
                <li class="lead">
                  Uygulama ve iletişim planını hazırlar ve hayata geçirir
                </li>
                <li class="lead">
                  Değişimini takip eder, raporlar ve paylaşır
                </li>
                <li class="lead">
                  Değişim hikayesini her türlü iletişim platformunda paylaşır,
                  ilham verir
                </li>
              </ul>
            </li>
            <li class="lead">
              <b>
                Kendi ekosisteminde de bir değişim hikayesi başlatmak üzere
                ekosistemindeki şirketlerle bir araya gelir, Platforma üye yapar
                ve değişimleri için onlara destek olur
              </b>
            </li>
          </ol>
          <p class="lead">BG Platformu üyelerine ne sağlar?</p>
          <ol class="pl-3 mb-2">
            <li class="lead">
              <b>KAPASİTE ARTIRMA ve İÇERİK:</b> Platform üye şirketlerin
              dönüşümlerini kolaylaştıracak içerik desteğini sağlar,
              kapasitelerini artırmak için kolaylaştırıcılık yapar
            </li>
            <li class="lead">
              <b>TAKİP ve RAPORLAMA:</b> Platform, üye şirketlerdeki ilerlemeyi
              raporlar, hikayeleri derler ve paylaşır
            </li>
            <li class="lead">
              <b>İLETİŞİM:</b> Platformun felsefesinin yaygınlaşması için
              iletişime çalışmaları yürütür
            </li>
          </ol>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    this.$root.$emit("loaded");
  }
};
</script>

<style></style>
